import {Avatar, Col, Form, Image, Row, Space, Tooltip} from "antd";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {UserOutlined} from "@ant-design/icons";
import {getImageSrc} from "pages/Receive/ExtendCard/config";
import {DataFormField} from "types/models/input-field-type";
import {InputFields} from "components/common";
import {
  birthday2Age,
  convertDateStringToDateTimezone_7,
  getItemLocalStorage,
  setItemLocalStorage,
} from "helper/common";
import {fieldsInforDetail1} from "../inforDetail.config";
import {catalogService, examOutService, medicalExaminationService} from "api";
import {FORMAT_TIME} from "types/enums";

type PatientInfoProps = {
  data: any;
  // fields: DataFormField[];
};

const PatientInfoCommon = ({data}: PatientInfoProps) => {
  const [fields, setFields] = useState(fieldsInforDetail1);
  const gender = () => {
    if (data) {
      if (data.gioiTinh === 0) {
        return "Nam";
      }
      if (data.gioiTinh === 1) {
        return "Nữ";
      }
    } else return "Không có";
  };

  const getLisDoctor = async () => {
    try {
      const res = await examOutService.getLisDoctor();
      const opt = res.data.map(el => ({
        value: `BS. ${el.hoTen}`,
        label: `BS. ${el.hoTen}`,
      }));

      fields.find(el => el.name === "bacSyKham").options = opt;
      setFields([...fields]);
    } catch (error) {
      getLisDoctor();
    }
  };
  useEffect(() => {
    const setOptionsTTKCB = async () => {
      try {
        const res = await catalogService.getListTrangThaiPhieu();

        const options = await res.map(e => {
          return {value: e.id, label: e.tenTTPhieuKham};
        });

        localStorage.setItem("TTPhieu", JSON.stringify(options));
        setItemLocalStorage("TTKCB", options);
        fields.find(e => e.name == "trangThai").options =
          getItemLocalStorage("TTKCB");
        setFields([...fields]);
      } catch (error) {}
    };

    setOptionsTTKCB();
  }, []);

  useEffect(() => {
    const setOptionsLoaiKCB = () => {
      try {
        console.log(getItemLocalStorage("loaiKCB"));
        fields.find(e => e.name == "loaiKCB").options =
          getItemLocalStorage("loaiKCB");
        setFields([...fields]);
      } catch (error) {}
    };

    setOptionsLoaiKCB();
  }, []);
  const getListPhongKham = async () => {
    try {
      const res = await catalogService.getListPhong();

      const optionsDetail =
        (await res.map(e => {
          return {
            value: e.id,
            label: `${e.tenPhong} (${e.soBenhNhan})`,
          };
        })) || [];

      localStorage.setItem("phongKhamYesPeople", JSON.stringify(optionsDetail));
      fields.find(e => e.name == "phong").options = optionsDetail;
      setFields([...fields]);
    } catch (error) {}
  };
  // getLisDoctor();
  useEffect(() => {
    getListPhongKham();
    getLisDoctor();
  }, []);
  return (
    <Row>
      <Col className="avatar" flex="150px">
        <Form.Item name={"anh"}>
          {data?.anh ? (
            <Image
              width={140}
              height={"auto"}
              src={getImageSrc(data.anh)}
              preview={false}
            />
          ) : (
            <Avatar icon={<UserOutlined />} shape="square" size={140} />
          )}
        </Form.Item>
      </Col>
      <Col flex={"1 0 0"}>
        <Space direction="vertical" size={"small"}>
          <Row gutter={[16, 16]}>
            <Form.Item
              initialValue={null}
              className="form"
              name="hoTenBN"
              style={{fontWeight: "bold"}}
            >
              {(data?.hoTen || data?.hoTenBN || data?.hoVaTen) ?? "Không có"} -
            </Form.Item>
            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="gioiTinh"
            >
              &nbsp;
              {gender()} -
            </Form.Item>
            <Form.Item
              initialValue={null}
              name="ngaySinh"
              style={{fontWeight: "bold"}}
              className="form"
            >
              &nbsp;
              {birthday2Age(data?.ngaySinh)}{" "}
              {birthday2Age(data?.ngaySinh).toString().includes("tháng")
                ? ""
                : "tuổi"}
              (SN:&nbsp;
              {data
                ? convertDateStringToDateTimezone_7(data?.ngaySinh).format(
                    FORMAT_TIME.dayFull
                  )
                : "Không có"}
              ) -
            </Form.Item>

            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="maBenhNhan"
            >
              &nbsp;
              <Tooltip title={"Mã bệnh nhân"}>
                {data?.maBenhNhan ?? "Không có"} -
              </Tooltip>
            </Form.Item>
            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="idPhieuKham"
            >
              &nbsp;
              <Tooltip title={"Mã phiếu khám"}>
                {(data?.idPhieuKham || data?.maKhamBenh) ?? "Không có"}
              </Tooltip>
            </Form.Item>
          </Row>

          <Row gutter={[16, 8]}>
            <InputFields data={fields} />
          </Row>
          {/* <Row gutter={[16, 16]}>
            <Form.Item
              initialValue={null}
              className="form"
              name="bmi"
              style={{fontWeight: "bold"}}
            >
              {`BMI = ` + (data?.bmi ? data?.bmi: '-') +  ` (` + (data?.canNang ? data?.canNang: '-') + 'kg ' + (data?.chieuCao ? data?.chieuCao: '-') + 'm);'}
            </Form.Item>
            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="huyetAp"
            >
              &nbsp;
              {`HA = ` + (data?.huyetAp ? data?.huyetAp: '-') + 'mmHg;'}
            </Form.Item>
            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="mach"
            >
              &nbsp;
              {`NhT = ` + (data?.mach ? data?.mach: '-') + 'bpm;'}
            </Form.Item>
            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="huyetAp"
            >
              &nbsp;
              {`NhA(T/P) = ` + (data?.nhanApMatTraiPhai ? data?.nhanApMatTraiPhai: '-') + '/112mmHg;'}
            </Form.Item>
            <Form.Item
              initialValue={null}
              className="form"
              style={{fontWeight: "bold"}}
              name="nhietDo"
            >
              &nbsp;
              {`T = ` + (data?.nhipTim ? data?.nhietDo: '-') + 'oC;'}
            </Form.Item>
          </Row> */}
        </Space>
      </Col>
    </Row>
  );
};

export default PatientInfoCommon;
